import { withInstall } from '@ll-plus/utils'

import Tooltip from './src/tooltip.vue'

export const LlTooltip = withInstall(Tooltip)
export default LlTooltip
export * from './src/tooltip'

declare module 'vue' {
  export interface GlobalComponents {
    LlTooltip: typeof Tooltip
  }
}
